module.exports = __webpack_public_path__ + "static/shopify_hand-c97638a255a5fed0f599efb3f6e2e13d.png";